import {Component, Vue} from 'vue-property-decorator'
import {getOutputRecord, sendOutput, sendOutputRecord} from "@/api/classManage";
import {string} from "mathjs";
import {menuBtn} from "@/utils/menu_level2_button";

@Component({})
export default class ProduceRecord extends Vue {
    id = null
    timer = null
    loading = false
    tableData = []
    limit = 20
    page = 1
    total = 0
    classesId = null
    financeOrderId = null
    buttonShow = menuBtn
    email = null
    dialogVisible = false
    produceId = null
    isFinish = false

    created() {
        this.classesId = this.$route.query.classesId
        this.financeOrderId = this.$route.query.financeOrderId
        this.isFinish = this.$route.query.isFinish == 'true' ? true : false
        this.getTableData()
    }

    getTableData() {
        const obj = {
            classesId: this.classesId,
            financeOrderId: this.financeOrderId,
            page: String(this.page),
            limit: String(this.limit)
        }
        getOutputRecord(obj).then((res: any) => {
            this.tableData = res.studentOutputList
            this.total = res.allNum
        })

    }

    handleSizeChange(val: number) {
        this.limit = val
        this.getTableData()
    }

    handleCurrentChange(val: number) {
        this.page = val
        this.getTableData()
    }

    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }

    /*查看产出记录详情*/
    handleScan(row) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/ClassStudentProduceInfo?id=' + row.id + '&email=' + this.email + '&status=' + row.status, "_blank")
        const time = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(time)
            }
        }, 500)
    }

    /*
    * 发送产出*/
    handleSend(row) {
        this.produceId = row.id
        this.dialogVisible = true
    }

    /*跳转新建产出*/
    openAddProduce() {
        /*判断是否有未发送的产出*/
        if (this.tableData.some(item => item.status === '未发送')) {
            this.$message({
                message: '存在未发送的产出，请先发送',
                type: 'warning'
            })
            return
        }

        const win = window.open(window.location.origin + this.$route.matched[0].path + '/AddClassStudentProduce?classId=' + this.classesId + '&financeOrderId=' + this.financeOrderId + '&isFinish=' + this.isFinish, "_blank")
        const time = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(time)
            }
        }, 500)
    }
    // 确认发送
    confirmSendProduce() {
        this.dialogVisible = false
        sendOutputRecord(this.produceId).then((res: any) => {
            this.getTableData()
            this.$message({
                message: '发送成功',
                type: 'success'
            })
        })
    }

    /*调转编辑*/
    openEditProduce(row) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/AddClassStudentProduce?id=' + row.id+ '&isFinish=' + this.isFinish, "_blank")
        const timer = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(timer)
            }
        }, 500)
    }
}